export default "__VITE_ASSET__BbOpUF8Z__";